import type { ComponentType } from 'react';
import { hasFlag } from 'country-flag-icons';
import * as Flags from 'country-flag-icons/react/3x2';
import type { DropDownMenuItem } from '../ui/dropDownMenu';
import type { LanguageMenuSource, ResolveGameLocaleArgs } from './types';

function normalizeFlagCode(code: string): string {
    return code.trim().toUpperCase();
}

function getFlagComponent(code: string): ComponentType | null {
    const normalized = normalizeFlagCode(code);

    if (!hasFlag(normalized)) {
        return null;
    }

    return (
        (Flags as Record<string, ComponentType>)[normalized.replace(/-/g, '_')] ?? null
    );
}

export function toLanguageMenuItem(language: LanguageMenuSource): DropDownMenuItem {
    const Flag = getFlagComponent(language.flag);

    return {
        value: language.isoName,
        label: language.name,
        icon: Flag ? <Flag /> : undefined,
    };
}

export function resolveGameLocale({
    availableLocales,
    preferredLocale,
    defaultLocale,
}: ResolveGameLocaleArgs): string {
    if (availableLocales.some((item) => item.value === preferredLocale)) {
        return preferredLocale;
    }

    return (
        availableLocales.find((item) => item.value === defaultLocale)?.value ??
        availableLocales[0]?.value ??
        defaultLocale
    );
}
